<template>
  <!-- 案件详情-公示信息 -->
  <section class="container-public">
    <el-card class="content-block">
      <div slot="header" class="clearfix">
        <span class="bold">公示信息</span>
      </div>
      <div class="item-block">
        <ul class="message-block flex">
          <li class="list-block flex">
            公示日期：
            <p class="txt">{{ caseInfo.publicityStart }}</p>
          </li>
          <li class="list-block flex">
            公示金额：
            <p v-if="caseInfo.raiseAmount > 10000" class="txt">{{ raiseAmount }}万元</p>
            <p v-else class="txt">{{ caseInfo.raiseAmount }}元</p>
          </li>
          <li class="list-block flex">
            划款日期：
            <p class="txt">{{ caseInfo.transferTime }}</p>
          </li>
          <li class="list-block flex">
            划款金额：
            <p v-if="caseInfo.actualRaiseAmount > 10000" class="txt">
              {{ actualRaiseAmount }}万元
            </p>
            <p v-else class="txt">{{ caseInfo.actualRaiseAmount }}元</p>
          </li>
        </ul>
      </div>
    </el-card>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import NP from 'number-precision' // 使用js精确地执行加法、减法、乘法和除法运算

export default {
  name: 'Publicity',

  computed: {
    ...mapState({
      caseInfo: (state) => state.caseDetail.caseInfo
    }),

    /**
     * 公示金额
     */
    raiseAmount() {
      const { caseInfo } = this
      if (caseInfo.raiseAmount > 10000) {
        return NP.divide(caseInfo.raiseAmount, 10000)
      } else {
        return 0
      }
    },

    /**
     * 划款金额
     */
    actualRaiseAmount() {
      const { caseInfo } = this
      if (caseInfo.actualRaiseAmount > 10000) {
        return NP.divide(caseInfo.actualRaiseAmount, 10000)
      } else {
        return 0
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>
